import React from 'react';
import _ from 'lodash';
import { withFormsy } from 'formsy-react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel } from '@mui/material';

class CheckboxGroupInput extends React.Component {
  constructor(props) {
    super(props);

    if (this.props.value) {
      this.props.setValue(this.props.value);
    }
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    const {value, checked} = event.target;
    const values = this.props.value || [];
    const newValues = checked ? _.concat(values, value) : _.pull(values, value);
    this.props.setValue(newValues);
  }

  render() {
    const { value, label, options, required, hint, errorMessage, isPristine } = this.props;
    const error = !isPristine && errorMessage != null;

    return (
      <div className="input-container">
        <FormControl component="fieldset" error={error}>
          <FormLabel required={required}>
            {label}
          </FormLabel>
          <FormGroup>
            {options.map((option, i) => (
              <FormControlLabel
                key={i}
                control={<Checkbox value={option} onChange={this.changeValue} checked={_.includes(value, option)}/>}
                label={option}
              />
            ))}
          </FormGroup>

          <span aria-live="polite">
            {error &&
              <FormHelperText error>{errorMessage}</FormHelperText>
            }
          </span>
          {hint &&
            <FormHelperText>{hint}</FormHelperText>
          }
        </FormControl>
      </div>
    );
  }
}

export default withFormsy(CheckboxGroupInput);
